const defaultNotInvolvedId = "11111111111111111111111111111111"; 

export {
    defaultNotInvolvedId
}